import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GlobalSearchRequest } from '../models/api/globalSearchRequest';
import { GlobalSearchResultDto } from '../models/api/globalSearchResultDto';
import { PaginatedResponse } from '../models/paginatedResponse';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  /**
   * Search across companies, OPB companies, directors, and large shareholders by name
   */
  search(request: GlobalSearchRequest): Observable<PaginatedResponse<GlobalSearchResultDto>> {
    return this.http.post<PaginatedResponse<GlobalSearchResultDto>>(`${this.apiUrl}/global-search`, request);
  }
}
